
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-drive/chezcitroen",
      function () {
        return require("private-next-pages/test-drive/chezcitroen/index.js");
      }
    ]);
  